import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'
import {CoordinatorsService} from '../../../services/coordinators.service'
import { SharedService } from 'app/modules/common/services/shared-service';
@Component({
    selector: 'app-coordinator-add-list',
    templateUrl: './coordinator-add-list.component.html',
    styleUrls: ['./coordinator-add-list.component.scss'],
    standalone: false
})
export class CoordinatorAddListComponent implements OnInit {
  public addDoctorForm: UntypedFormGroup;
  constructor(
    private _dialogRef: MatDialogRef<CoordinatorAddListComponent>,
    private _coordinatorsService:CoordinatorsService,
    private _sharedService: SharedService
    ) {
      this.addDoctorForm = new UntypedFormGroup({
        Nombre: new UntypedFormControl('', Validators.required),
      });
     }

  ngOnInit(): void {
    
  }

  public onClose(res): void {
    this._dialogRef.close(res);
  }
  public onSave():void{
    this.addDoctorForm.markAllAsTouched();
    this.addDoctorForm.updateValueAndValidity();
    if (this.addDoctorForm.valid) {
      this._coordinatorsService.AddCoordinators(this.addDoctorForm.value).subscribe(res => {   
        if(res)
        {
          this.onClose(res)
          this._sharedService.ShowSnackBar('Insertado correctamente', 'Okay', 2000);
        }
      }, err => {
      console.error(err);
        this.onClose(err);
        this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
      })
    }
  }

}
